import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PlaylistDayStoreEffects } from './playlist-day.effects';
import { dayReducer, featureKey } from './playlist-day.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKey, dayReducer),
    EffectsModule.forFeature([PlaylistDayStoreEffects]),
  ],
  providers: [PlaylistDayStoreEffects],
})
export class PlaylistDayStoreModule { }
